import React from 'react';
// import ReactGA from 'react-ga';
import { initGA, PageView } from './components/TrackingId';
import './App.css';
import { Route, Switch, HashRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { fetchTokenPath } from './Services/config/apiGateway';
import Layout from './Layout/Layout';
// import Layout from './layout/Layout'; // Test Env
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.min.css';
import createAuthContext from './lib/createAuthContext'

//const cryptoRandomString = require('crypto-random-string');

//const e_State = cryptoRandomString({length: 10, type: 'alphanumeric'})
const clientId = process.env.REACT_APP_CLIENT_ID || "1ad286a0-ab7d-4952-bfe4-5f47eafaac7f"
const provider = process.env.REACT_APP_PROVIDER || `${fetchTokenPath}auth?state=ubNUF&`
// const provider = process.env.REACT_APP_PROVIDER || `https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/auth?state=ubNUF&`
// const provider = process.env.REACT_APP_PROVIDER || `https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/auth?state=ubNUF&`
const {AuthContext, Authenticated, useToken} = createAuthContext({
  clientId,
  provider,
  scopes:["f1d4d39a-5888-481c-a562-a49d7748f054 offline_access"],
})

function App() {
//  console.log = () =>{}
  const loaderValueR = useSelector(state => state.loaderReducer.loaderValue);
  initGA('UA-182650766-1');
  PageView();
  return (
    <div id={!loaderValueR ? "disabletrue" : ""}>
    <AuthContext><Authenticated>
      <HashRouter>
        <Switch>
        
          {/* <Route exact path="/" component={Home} /> */}
          <Route path='/' render={(props) => <Layout {...props} /> } />
        </Switch>
      </HashRouter></Authenticated></AuthContext>
    </div>
  );
}

App.propTypes = {
  match: PropTypes.any.isRequired,
  history: PropTypes.func.isRequired
}

export default App;
